/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Warning: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_893)'>
      <path
        d='M23.6413 18.4849L14.7323 1.64289C14.469 1.14681 14.0756 0.731788 13.5943 0.442354C13.1129 0.152921 12.5619 0 12.0003 0C11.4387 0 10.8876 0.152921 10.4063 0.442354C9.92502 0.731788 9.5316 1.14681 9.26829 1.64289L0.359287 18.4849C0.111516 18.9548 -0.0104486 19.4809 0.00525133 20.0119C0.0209512 20.5429 0.173781 21.0608 0.448883 21.5153C0.723985 21.9698 1.112 22.3454 1.5752 22.6055C2.0384 22.8656 2.56104 23.0015 3.09229 22.9999H20.9083C21.4395 23.0015 21.9622 22.8656 22.4254 22.6055C22.8886 22.3454 23.2766 21.9698 23.5517 21.5153C23.8268 21.0608 23.9796 20.5429 23.9953 20.0119C24.011 19.4809 23.8891 18.9548 23.6413 18.4849ZM12.0003 19.9999C11.7036 19.9999 11.4136 19.9119 11.1669 19.7471C10.9203 19.5823 10.728 19.348 10.6145 19.0739C10.5009 18.7998 10.4712 18.4982 10.5291 18.2073C10.587 17.9163 10.7298 17.649 10.9396 17.4392C11.1494 17.2295 11.4167 17.0866 11.7077 17.0287C11.9986 16.9708 12.3002 17.0005 12.5743 17.1141C12.8484 17.2276 13.0827 17.4199 13.2475 17.6665C13.4123 17.9132 13.5003 18.2032 13.5003 18.4999C13.5003 18.8977 13.3423 19.2792 13.0609 19.5605C12.7796 19.8419 12.3981 19.9999 12.0003 19.9999ZM13.0003 14.9999H11.0003L10.5003 6.99989H13.5003L13.0003 14.9999Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_893'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
